<template>
  <v-container>
    <div v-if="!$store.state.globalLoading && $store.state.userData != null">
      <v-row wrap>
        <v-flex xs2>
          <v-btn
            color="orange"
            text
            large
            @click="$router.push({'name': 'Home'})"
          >
            < Home
          </v-btn>
        </v-flex>
        <v-flex xs12 sm8 class="text-center">
          <span class="mr-5 headline pa-2">Account Details</span>
          <p class="px-2 body-1 grey--text">Manage your preferences.</p>

        </v-flex>
        <v-flex xs2>

        </v-flex>
      </v-row>
      <v-layout row>
        <v-flex xs12 sm6>
          <v-text-field
            class="pa-2"
            label="First Name"
            v-model="$store.state.userData.firstname"
            outlined
            @change="updateEntry('firstname', $store.state.userData.firstname)"
            >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            class="pa-2"
            label="Last Name"
            v-model="$store.state.userData.lastname"
            outlined
            @change="updateEntry('lastname', $store.state.userData.lastname)"
            >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            disabled
            class="pa-2"
            label="Email"
            v-model="$store.state.userData.email"
            outlined
            >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            disabled
            class="pa-2"
            label="Domain Authorization"
            v-model="$store.state.userData.domainAuth"
            outlined
            >
          </v-text-field>
        </v-flex>
        <v-flex xs12 class="pa-2 mb-5">
          <div class="mt-3">
            Need help? Please email our <a href="mailto:support@omentum.freshdesk.com">support team</a>.
          </div>
        </v-flex>

        <v-flex xs12 class="pa-2 mb-5">
          <div>Policies</div>
          <div>
            <a href="/privacy" target="_blank">Privacy Policy</a>
          </div>
          <div>
            <a href="/tou" target="_blank">Terms of Use</a>
          </div>
        </v-flex>

        <v-flex xs12 class="pa-2">
          <p>To request that your account be deleted along with all associated data,
            please email inquiry@omentum.app, from the email associated with your account,
            with the subject "Request Account Deletion".
          </p>
        </v-flex>
      </v-layout>

    </div>
  </v-container>
</template>
<script>
import firebase from 'firebase'
export default {
  name: 'Account',
  data() {
    return {

    }
  },
  methods: {
    updateEntry(field, value) {
      let update = {}
      update[field] = value
      firebase.firestore().collection('users')
      .doc(firebase.auth().currentUser.uid)
      .update(update)
      .then(() => {
        this.$store.commit('snackbarMessageSet', {
          color: 'purple lighten-2',
          message: 'Your account details have been updated.'
        })
      })
    },
    requestDeletion() {
      let message = 'mailto:' + 'support@omentum.app'
      message += '?subject=Request%20Account%20Deletion%20for%20' + this.$store.state.userData.email
      message += '&body=This is a formal request to permanently and irreversibly delete my account (' + this.$store.state.userData.email
      message += ') and all associated account data.'
      return message
    }
  }

}
</script>
<style>

</style>
